import React, { useEffect } from "react";
import { NavLink } from "react-router";
import LoadingSpinner from "../../../../../components/loading";
import { ROUTES } from "../../../../../routes";
import { useCurrentUser } from "../../../../../store/current-user";
import useWishlist from "../../../../../store/wishlist";

export default function WishlistCount() {
  const { fetchWishlistCount, isFetchingWishlistCount, wishlistCount } = useWishlist();
  const [currentUser, , fetchCurrentUser] = useCurrentUser();

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  useEffect(() => { 
    if(currentUser) {
      (async function() {
        await fetchWishlistCount(currentUser.id);
      }())
    }
  }, [currentUser]);

  return (
    <NavLink to={ROUTES.WISHLIST}>
      { isFetchingWishlistCount &&
        <span className="wishlist-item-count loading">
          <LoadingSpinner />
        </span>
      }
      { !isFetchingWishlistCount && 
        <span className="wishlist-item-count">
          {wishlistCount}
        </span>
      }

      <i className="fa fa-heart-o"></i>
    </NavLink>
  );
}
